(function () {
  function setMenuState(menuBlock, isOpen) {
    var title = menuBlock.querySelector('.footer-menu-title');
    var links = menuBlock.querySelector('.footer-menu-links');
    if (!title) return;

    menuBlock.classList.toggle('is-open', isOpen);
    title.setAttribute('aria-expanded', isOpen ? 'true' : 'false');

    if (!links) return;

    if (isOpen) {
      links.style.maxHeight = links.scrollHeight + 'px';
      links.style.opacity = '1';
    } else {
      links.style.maxHeight = '0px';
      links.style.opacity = '0';
    }
  }

  function setupMobileAccordion(footerColumn) {
    var menuBlocks = footerColumn.querySelectorAll('.footer-menu-block');

    menuBlocks.forEach(function (menuBlock) {
      var title = menuBlock.querySelector('.footer-menu-title');
      var links = menuBlock.querySelector('.footer-menu-links');
      if (!title || !links) return;

      if (!links.id) {
        links.id = 'footer-menu-links-' + footerColumn.id + '-' + Math.random().toString(36).slice(2, 9);
      }

      title.setAttribute('role', 'button');
      title.setAttribute('tabindex', '0');
      title.setAttribute('aria-controls', links.id);
      setMenuState(menuBlock, menuBlock.classList.contains('is-open'));

      if (menuBlock.dataset.mobileAccordionInit === 'true') return;
      menuBlock.dataset.mobileAccordionInit = 'true';

      title.addEventListener('click', function () {
        setMenuState(menuBlock, !menuBlock.classList.contains('is-open'));
      });

      title.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        setMenuState(menuBlock, !menuBlock.classList.contains('is-open'));
      });
    });
  }

  function teardownMobileAccordion(footerColumn) {
    var menuBlocks = footerColumn.querySelectorAll('.footer-menu-block');

    menuBlocks.forEach(function (menuBlock) {
      var title = menuBlock.querySelector('.footer-menu-title');
      var links = menuBlock.querySelector('.footer-menu-links');
      if (!title) return;

      menuBlock.classList.remove('is-open');
      title.removeAttribute('role');
      title.removeAttribute('tabindex');
      title.removeAttribute('aria-expanded');
      title.removeAttribute('aria-controls');

      if (!links) return;
      links.style.removeProperty('max-height');
      links.style.removeProperty('opacity');
    });
  }

  function initFooterMobileAccordion(root) {
    var scope = root || document;
    var footerColumns = scope.querySelectorAll('[data-mobile-accordion="true"]');

    footerColumns.forEach(function (footerColumn) {
      var mobileQuery = window.matchMedia('(max-width: 767px)');

      var updateAccordionMode = function () {
        if (mobileQuery.matches) {
          setupMobileAccordion(footerColumn);
        } else {
          teardownMobileAccordion(footerColumn);
        }
      };

      updateAccordionMode();

      if (footerColumn.dataset.mobileAccordionMediaBound === 'true') return;
      footerColumn.dataset.mobileAccordionMediaBound = 'true';

      if (mobileQuery.addEventListener) {
        mobileQuery.addEventListener('change', updateAccordionMode);
      } else if (mobileQuery.addListener) {
        mobileQuery.addListener(updateAccordionMode);
      }
    });
  }

  window.initFooterMobileAccordion = initFooterMobileAccordion;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initFooterMobileAccordion(document);
    });
  } else {
    initFooterMobileAccordion(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initFooterMobileAccordion(event.target);
  });
})();
